/**
 * Debug utility to help diagnose authentication issues
 * Use this in the browser console: window.debugAuth()
 */

export function setupAuthDebugger() {
  (window as any).debugAuth = () => {
    console.group('🔍 Authentication Debug Info');

    // Check localStorage
    const authToken = localStorage.getItem('auth_token');
    const user = localStorage.getItem('user');

    console.log('Auth Token:', authToken ? '✓ Present' : '✗ Missing');
    if (authToken) {
      console.log('  - Length:', authToken.length);
      console.log('  - Preview:', authToken.substring(0, 50) + '...');

      // Try to decode JWT
      try {
        const parts = authToken.split('.');
        if (parts.length === 3) {
          const payload = JSON.parse(atob(parts[1]));
          console.log('  - Payload:', payload);

          // Check expiration
          if (payload.exp) {
            const expirationDate = new Date(payload.exp * 1000);
            const now = new Date();
            const isExpired = expirationDate < now;
            console.log('  - Expires:', expirationDate.toLocaleString());
            console.log('  - Status:', isExpired ? '✗ EXPIRED' : '✓ Valid');
          }
        }
      } catch (e) {
        console.error('  - Failed to decode JWT:', e);
      }
    }

    console.log('\nUser Info:', user ? '✓ Present' : '✗ Missing');
    if (user) {
      try {
        const userObj = JSON.parse(user);
        console.log('  - Data:', userObj);
      } catch (e) {
        console.error('  - Failed to parse user data:', e);
      }
    }

    console.groupEnd();

    // Provide quick actions
    console.log('\n💡 Quick Actions:');
    console.log('  - Clear auth: clearAuth()');
    console.log('  - Test token: testToken()');
  };

  (window as any).clearAuth = () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user');
    localStorage.removeItem('user_info');
    console.log('✓ Auth cleared. Reload the page to log in again.');
    setTimeout(() => {
      window.location.href = '/login';
    }, 1000);
  };

  (window as any).testToken = async () => {
    const token = localStorage.getItem('auth_token');
    if (!token) {
      console.error('✗ No token found');
      return;
    }

    console.log('Testing token with backend...');

    try {
      const response = await fetch('/api/auth/verify', {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        console.log('✓ Token is valid!', data);
      } else {
        const error = await response.text();
        console.error('✗ Token rejected:', response.status, error);
      }
    } catch (error) {
      console.error('✗ Request failed:', error);
    }
  };
}
